import { notification } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import Hotkeys from 'react-hot-keys';
import orderMedicineCart, {
    Order,
    Request as RequestPayload,
} from '../../../../api/orderMedicineCart';
import fetchMedicinesByPrescriptionId, {
    Response,
    CartMxEntity,
} from '../../../../api/fetchMedicinesByPrescriptionId';
import updateMedicineCart from '../../../../api/updateMedicineCart';
import { SlideFromRightWrapper } from '../../../common/SlideFromRightWrapper';
import {
    DeliveryAddressMapSVG,
    Loader,
    IGNORE_KEYS,
    FormInput,
    RecipientDetails,
    isPriceIsInvalid,
    UnavailablePriceFAQsIcon,
    GetDeliveryTypeMainBanner,
    GetDeliveryTypeSecondaryBanner,
    OrderDetailsComponent,
    getSteps,
    DeliveryETA,
    ExtraChargesList,
    paymodeObject,
    ONEMG,
    OneMgSvg,
    QuantityComponent,
    Discount,
    getPrescription,
} from './OrderMedicineUtils';
import { PatientFormData } from '../../../../api/fetchPatientDirByDocOid';
import getMedicinesOrder from '../../../../api/getMedicinesOrder';
import AddAddressModal, { Address } from './AddAddressModal';
import { track } from '../../../../tracking';
import fetchPatientAddress, { Add } from '../../../../api/fetchPatientAddress';
import AddRecipientModal from './AddRecipientModal';
import SelectPaymodeModal from './SelectPaymodeModal';
import UnavailablePriceFAQsModal from './UnavailablePriceFAQsModal';
import { ShepherdTour } from 'react-shepherd';
import {
    Button,
    FinishedPageFooter,
    stepsForFinishState,
} from '../../../../pages/trialOrder/Utils';
import ExitTrialWarningModal from './ExitTrialWarningModal';
import { checkIfValidPhoneNumber, fetchAllVisits, openCrispChat } from '../../../../pages/utils';
import { OrderDetails } from '../../../../api/fetchAllHEOrder';
import CancelOrderOrBooking from '../../../../pages/CancelOrderOrBooking';
import { AntTooltip } from '../../../common/AntTooltip';
import capitalize from 'lodash/capitalize';
import PrescribeAutoSuggestV2 from '../workspace/PrescribeAutoSuggestV2';
import {
    InjectionsEntity,
    LabTestsEntityOrProceduresEntity,
    MedicationsEntity,
    Prescription,
} from '../../../../store/types/prescription';
import { Patient } from '../../../../store/types/patient';
import {
    MISC_KEYS,
    getItemFromMisc,
    getMySingleDoctorId,
    getPrintConfig,
} from '../../../../store/idbHandler';
import { Translate } from '../../../../api/pushVisit';
import { pushVisitWithSanitizePrescription } from './FinishedPanel';
import { captureError, captureErrorString } from '../../../../pages/captureError';
import setHEOnboardingProfile from '../../../../api/setHEOnboardingProfile';
import { ACTIVE_TAB } from '../../../../pages/HEDashboard';
import { getMyDbId } from '../../../../api/mactiveid';

const OrderMedicine: React.FC<{
    closeMe: () => void;
    formData: PatientFormData[];
    patientId: string;
    name: string;
    phone: string;
    gender: string;
    pxid: string;
    age: number;
    clinicPin: string;
    orderId?: string;
    isForTrialOrder?: boolean;
    changeSteps?: (activeStep?: number) => void;
    showGoToHEDashboardButton?: boolean;
    isForQuickCart?: boolean;
    patient?: Patient;
    hideBackButton?: boolean;
}> = ({
    closeMe,
    formData,
    patientId,
    name,
    phone,
    gender,
    pxid,
    age,
    clinicPin,
    orderId,
    isForTrialOrder,
    changeSteps,
    showGoToHEDashboardButton,
    isForQuickCart,
    patient,
    hideBackButton,
}) => {
    const [response, setResponse] = useState<Response>();
    const [cart, setCart] = useState<CartMxEntity[]>([]);
    const [removedCart, setRemovedCart] = useState<CartMxEntity[]>([]);
    const [notAvailableCart, setNotAvailableCart] = useState<CartMxEntity[]>([]);
    const [isFinish, setIsFinish] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [isShow, setIsShow] = useState(false);
    const [pincode, setPincode] = useState('');
    const [discount, setDiscount] = useState('');
    const [discountInp, setDiscountInp] = useState('');
    const [finishState, setFinishState] = useState<Order[]>();
    const [formInput, setFormInput] = useState<FormInput>({
        line: '',
        landmark: '',
        city: '',
        state: '',
        city_id: '',
        place_id: '',
        coordinates: '',
    });
    const [isPlaceOrderLoading, setIsPlaceOrderLoading] = useState(false);
    const [isVerifyPincodeLoading, setIsVerifyPincodeLoading] = useState(false);
    const [isApplyDiscountLoading, setIsApplyDiscountLoading] = useState(false);
    const [showAddAddress, setShowAddAddress] = useState(false);
    const [isFetchingOrder, setIsFetchingOrder] = useState(false);
    const [showFilledAddress, setShowFilledAddress] = useState(false);
    const [isCartError, setIsCartError] = useState(false);
    const [patientAddressArray, setPatientAddressArray] = useState<Add[]>([]);
    const [isNewAddress, setIsNewAddress] = useState(false);
    const [showForm, setShowForm] = useState(true);
    const [recipientDetails, setRecipientDetails] = useState<RecipientDetails>({
        name,
        mobile: phone,
        alternative_mobile:
            (formData.find((i) => i.key === 'aphone')?.value as string)?.slice(-10) || '',
    });
    const [showAddRecipient, setShowAddRecipient] = useState(false);
    const [paymode, setPaymode] = useState('');
    const [showSelectPaymode, setShowSelectPaymode] = useState(false);
    const [showUnavailablePriceFAQs, setShowUnavailablePriceFAQs] = useState(false);
    const [currentOrderIndex, setCurrentOrderIndex] = useState(0);
    const [showExitTrialWarningModal, setShowExitTrialWarningModal] = useState(false);
    const [activeOrder, setActiveOrder] = useState<OrderDetails>();
    const [prescriptionMedications, setPrescriptionMedications] = useState<MedicationsEntity[]>([]);
    const [isFetchingLastRx, setIsFetchingLastRx] = useState(false);
    const [lastRxMedications, setLastRxMedications] = useState<MedicationsEntity[]>([]);

    const docId = getMySingleDoctorId() || '';

    useEffect(() => {
        const pincode = (formData.find((i) => i.key === 'pincode')?.value ||
            clinicPin ||
            '') as string;
        setPincode(pincode);

        if (isForQuickCart) {
            fetchPtAddress(isForQuickCart);
            fetchFromLastRx();
        } else {
            setIsFetchingOrder(true);
            const pxId = !orderId ? pxid : '';
            getMedicinesOrder(pxId, orderId)
                .then((i) => {
                    if (i.success) {
                        setIsFinish(true);
                        setFinishState(i.data);
                    } else {
                        fetchPtAddress();
                    }
                    setIsFetchingOrder(false);
                })
                .catch((err) => {
                    console.log(err);
                    fetchPtAddress();
                });
        }
    }, []);

    const fetchPtAddress = (isForQuickCart?: boolean): void => {
        const pincode = (formData.find((i) => i.key === 'pincode')?.value ||
            clinicPin ||
            '') as string;
        isForQuickCart && setIsVerifyPincodeLoading(true);
        fetchPatientAddress(docId, patientId)
            .then((i) => {
                setPatientAddressArray(i.address);
                const addressArray = i.address;

                if (addressArray[0]?.address) {
                    const { address } = addressArray[0] as Add;
                    setFormInput({
                        ...address,
                        _id: addressArray[0]._id,
                        line: address.line1,
                        landmark: address.line2,
                    });
                    const { pincode } = address;
                    if (!isForQuickCart && pincode.length === 6) pincodeHandler(pincode);
                    setPincode(pincode);
                    setShowFilledAddress(true);
                } else {
                    setIsNewAddress(true);
                    if (!isForQuickCart && pincode.length === 6) pincodeHandler(pincode);
                }
            })
            .catch((err) => {
                console.log(err);
                if (!isForQuickCart && pincode.length === 6) pincodeHandler(pincode);
            })
            .finally(() => {
                setIsFetchingOrder(false);
                isForQuickCart && setIsVerifyPincodeLoading(false);
                isForQuickCart && setIsShow(true);
            });
    };

    const fetchFromLastRx = async () => {
        try {
            setIsFetchingLastRx(true);
            const response = await fetchAllVisits(patientId, 1);
            if (response?.state === 'success' && response?.data) {
                const lastVisit = response.data?.sort((date1, date2) => {
                    return date1 > date2 ? -1 : 1;
                })[0];
                if (lastVisit && lastVisit.medications && lastVisit.medications.length > 0) {
                    const lastRxMedications = lastVisit.medications;
                    setLastRxMedications(lastRxMedications);
                }
            }
        } catch (error) {
            captureError(error as Error);
            track('ERROR', {
                on: 'fetchFromLastRx [Medications]',
                error: (error as Error).message,
            });
        } finally {
            setIsFetchingLastRx(false);
        }
    };

    const cartHandler = (id: string, type: string) => {
        setIsUpdate(true);
        const cart_mx = cart.map((i) => {
            if (i.eka_id === id) {
                if (type === 'plus') i.qty++;
                else if (type === 'minus' && i.qty !== 1) i.qty--;
            }
            return i;
        });
        setCart(cart_mx);
    };

    const pincodeHandler = (pincode: string, eka_mx?: MedicationsEntity[]) => {
        if (pincode.length !== 6) {
            notification.error({
                message: 'Enter valid pincode',
                duration: 5,
            });
            return;
        }
        setIsVerifyPincodeLoading(true);
        fetchMedicinesByPrescriptionId(docId, {
            [eka_mx ? 'eka_mx' : 'pxid']: eka_mx || pxid,
            pxid,
            pincode,
            docid: docId,
            patientid: patientId,
            discount: 0,
        })
            .then((i) => {
                if (i.success) {
                    setIsShow(true);
                    setResponse(i);
                    setCart(i.cart_mx as CartMxEntity[]);
                    setNotAvailableCart(i.unavailable_mx as CartMxEntity[]);
                    setIsUpdate(false);
                    const isInvalidPrice = isPriceIsInvalid(i.cart_mx);
                    if (isForTrialOrder) {
                        setPaymode('FREE');
                    } else if (isInvalidPrice) {
                        setPaymode('COD');
                    } else if (i.paymodes && i.paymodes.length === 1) {
                        setPaymode(i.paymodes[0]);
                    }
                    setTimeout(() => {
                        const startTourButton = document.getElementById('start-tour');
                        startTourButton && startTourButton.click();
                    }, 1000);
                    track('CREATE_MEDICINE_CART_SUCCESS', {
                        pxId: pxid,
                        isInvalidPrice: isInvalidPrice ? 'true' : 'false',
                    });
                } else {
                    notification.error({
                        message: i.error,
                        duration: 5,
                    });
                    if (i.error === 'No Medicines prescribed') setIsCartError(true);
                    track('CREATE_MEDICINE_CART_ERROR', { error: i.error });
                }
            })
            .catch((e) => {
                notification.error({
                    message: 'Fetch Medicines => ' + e,
                    duration: 5,
                });
                track('CREATE_MEDICINE_CART_ERROR', { error: (e as Error).message });
            })
            .finally(() => {
                setIsVerifyPincodeLoading(false);
                setIsApplyDiscountLoading(false);
            });
    };

    const removeFromCart = (id: string) => {
        setIsUpdate(true);
        setCart(cart.filter((i) => i.eka_id !== id));
        setRemovedCart([...removedCart, cart.find((i) => i.eka_id === id) as CartMxEntity]);
    };

    const addToCart = (id: string) => {
        setIsUpdate(true);
        setRemovedCart(removedCart.filter((i) => i.eka_id !== id));
        setCart([...cart, removedCart.find((i) => i.eka_id === id) as CartMxEntity]);
    };

    const updateCartHandler = (pincode: string) => {
        if (pincode.length !== 6) {
            notification.error({
                message: 'Enter valid pincode',
                duration: 5,
            });
            return;
        }
        const MAX_DISCOUNT = Number(response?.in_clinic_max_discount) || 0;
        if (Number(discountInp) < 0 || Number(discountInp) > MAX_DISCOUNT) {
            notification.error({
                message: `Discount must be between 0 to ${MAX_DISCOUNT}`,
                duration: 5,
            });
            setDiscountInp(discount);
            return;
        }
        setDiscount(discountInp);

        setIsApplyDiscountLoading(true);
        updateMedicineCart(docId, {
            eka_mx: response?.eka_mx,
            cart_mx: cart.concat(response?.unavailable_mx || []),
            vendor: response?.vendor || '',
            vendor_error: response?.vendor_error || '',
            discount: discountInp,
            pincode: pincode,
            docid: docId,
            patientid: patientId,
        })
            .then((i) => {
                if (i.success) {
                    setResponse(i);
                    setCart(i.cart_mx as CartMxEntity[]);
                    setNotAvailableCart(i.unavailable_mx as CartMxEntity[]);
                    setIsUpdate(false);
                    const isInvalidPrice = isPriceIsInvalid(i.cart_mx);
                    if (isForTrialOrder) {
                        setPaymode('FREE');
                    } else if (isInvalidPrice) {
                        setPaymode('COD');
                    } else if (i.paymodes && i.paymodes.length === 1) {
                        setPaymode(i.paymodes[0]);
                    }
                    track('UPDATE_MEDICINE_CART_SUCCESS', {
                        pxId: pxid,
                        isInvalidPrice: isInvalidPrice ? 'true' : 'false',
                    });
                } else {
                    notification.error({
                        message: i.error,
                        duration: 5,
                    });
                    track('UPDATE_MEDICINE_CART_ERROR', { error: i.error });
                }
                setIsApplyDiscountLoading(false);
            })
            .catch((e) => {
                notification.error({
                    message: 'Update Cart => ' + e,
                    duration: 5,
                });
                setIsApplyDiscountLoading(false);
                track('UPDATE_MEDICINE_CART_ERROR', { error: (e as Error).message });
            });
    };

    const placeOrderHandler = async () => {
        if (pincode.length !== 6) {
            notification.error({
                message: 'Enter valid pincode',
                duration: 5,
            });
            return;
        }

        if (
            Object.entries(formInput).some(
                (i) =>
                    (i[0] === 'line' && i[1].length === 0) ||
                    (!IGNORE_KEYS.has(i[0]) && i[1].length < 3),
            )
        ) {
            notification.error({
                message: 'Enter delivery address',
                duration: 5,
            });
            return;
        }

        if (!paymode) return setShowSelectPaymode(true);

        const numberError = getNumberError(recipientDetails);
        if (numberError) {
            setShowAddRecipient(true);
            notification.error({
                message: `Enter valid ${numberError} number`,
                duration: 5,
            });
            return;
        }

        setIsPlaceOrderLoading(true);

        const requestPayload: RequestPayload = {
            docid: docId,
            patientid: patientId,
            pxid,
            address: {
                ...formInput,
                pincode,
            },
            customerDetails: {
                ...recipientDetails,
                gender: gender === 'other' ? 'others' : gender.toLowerCase(),
                age,
                email: formData?.find((i) => i.key === 'email')?.value as string,
            },
            cart,
            discount: parseInt(discount) || 0,
            pincode: pincode,
            vendor: response?.vendor || '',
            vendor_error: response?.vendor_error || '',
            paymode: isForTrialOrder ? 'EKA' : paymode,
            placedByDoctor: isForTrialOrder,
            extra_charges: response?.extra_charges,
            eta: response?.eta,
            eta_display: response?.eta_display,
            fareDict: response?.fareDict,
        };

        if (isForQuickCart) {
            const pc = await getPrintConfig(getMyDbId() || '');
            const t = await getItemFromMisc<Translate>(getMyDbId() || '', MISC_KEYS.translate);

            const prescription = getPrescription(
                patient as Patient,
                prescriptionMedications,
            ) as Prescription;
            try {
                const response = await pushVisitWithSanitizePrescription(
                    prescription,
                    new Date(),
                    new Date(),
                    'send',
                    pc,
                    t,
                    undefined,
                    undefined,
                    false,
                );
                if (response.status !== 'success') {
                    notification.error({
                        message: 'Failed to save presciption',
                        duration: 5,
                    });
                    captureErrorString('Failed to save presciption [Lab Tests]');
                    track('ERROR', {
                        on: 'pushVisitWithSanitizePrescription',
                        what: 'Failed to save presciption [Lab Tests]',
                    });
                    setIsPlaceOrderLoading(false);
                    return;
                }
            } catch (err) {
                notification.error({
                    message: 'Failed to save presciption => ' + err,
                    duration: 5,
                });
                captureError(err as Error);
                track('ERROR', {
                    on: 'pushVisitWithSanitizePrescription',
                    error: (err as Error).message,
                });
                setIsPlaceOrderLoading(false);
                return;
            }
            requestPayload.pxid = prescription.id;
        }

        if (isForTrialOrder) {
            try {
                await setHEOnboardingProfile({ isTrialOrderPlaced: true });
            } catch (err) {
                captureError(err as Error);
                track('ERROR', {
                    on: 'setHEOnboardingProfile [Mark pharma trial order]',
                    error: (err as Error).message,
                });
            }
        }

        orderMedicineCart(docId, requestPayload)
            .then((i) => {
                if (i.success) {
                    setIsFinish(true);
                    setFinishState([i.order]);
                    const isInvalidPrice = isPriceIsInvalid(cart);
                    changeSteps && changeSteps();
                    handleCloseTour();
                    setTimeout(() => {
                        const startTourButton = document.getElementById('start-tour');
                        startTourButton && startTourButton.click();
                    }, 1000);
                    track('ORDER_MEDICINE_CART_SUCCESS', {
                        pxId: pxid,
                        isInvalidPrice: isInvalidPrice ? 'true' : 'false',
                        isForTrialOrder: String(Boolean(isForTrialOrder)),
                        isForQuickCart: String(Boolean(isForQuickCart)),
                    });
                } else {
                    notification.error({
                        message: i.error,
                        duration: 5,
                    });
                    track('ORDER_MEDICINE_CART_ERROR', { error: i.error });
                }
                setIsPlaceOrderLoading(false);
            })
            .catch((e) => {
                notification.error({
                    message: 'Place Order => ' + e,
                    duration: 5,
                });
                setIsPlaceOrderLoading(false);
                track('ORDER_MEDICINE_CART_ERROR', { error: (e as Error).message });
            });
    };

    const setAddressHandler = (add: Address) => {
        setFormInput({
            _id: add._id,
            line: add.line,
            landmark: add.address,
            city: add.city,
            state: add.state,
            coordinates: `${add.latLng}`,
            place_id: add.placeID,
            city_id: '',
        });
        setPincode(add.pincode);
        setShowAddAddress(false);
        isShow && setIsUpdate(true);
        isShow ? updateCartHandler(add.pincode) : pincodeHandler(add.pincode);
        setShowFilledAddress(true);
    };

    const setRecipientHandler = (recipientDetails: RecipientDetails) => {
        setRecipientDetails(recipientDetails);
        setShowAddRecipient(false);
    };

    const paymodeHandler = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = e.target;
        setPaymode(value);
        track('ORDER_MEDICINE_PAYMODE_CHANGE', {
            pxId: pxid,
            paymode: value,
        });
    };

    const showFAQsHandler = () => {
        setShowUnavailablePriceFAQs(true);
        track('ORDER_MEDICINE_SHOW_FAQs', {
            pxId: pxid,
        });
    };

    const handleCloseTour = () => {
        const shepherdTourDivs = document.getElementsByClassName(
            'shepherd-tour',
        ) as HTMLCollectionOf<HTMLElement>;
        Array.from(shepherdTourDivs).forEach((ele) => ele && ele.remove());
        changeSteps && changeSteps();
    };

    const exitTrialToggleHandler = () => {
        setShowExitTrialWarningModal(!showExitTrialWarningModal);
        track('EXIT_TRIAL_BUTTON_CLICK', {
            action: showExitTrialWarningModal ? 'close' : 'open',
        });
    };

    const toggleActiveOrder = (order?: OrderDetails) => {
        if (order?.status === 'cancelled') {
            notification.error({
                message: 'Error: Order already cancelled!',
                duration: 5,
                placement: 'topRight',
            });
            return;
        }
        setActiveOrder(order);
        if (order) {
            track('CANCEL_ORDER_OR_BOOKING', {
                from: 'trial order',
                activeTab: ACTIVE_TAB.MEDS,
                order_id: order?.id,
            });
        }
    };

    const onNeedHelp = () => {
        if (finishState && finishState.length) {
            const { id, status, sub_status } = finishState[currentOrderIndex] as OrderDetails;
            openCrispChat(
                'NEED_HELP_HXNG',
                {
                    from: 'Order Dashboard',
                    type: 'pharma',
                    order_id: id,
                    status,
                    sub_status: sub_status,
                },
                `I have an issue with this Pharma order  - ${id} - Status : ${capitalize(status)} ${
                    sub_status ? `(${capitalize(sub_status)})` : ''
                }`,
            );
        } else {
            openCrispChat(
                'NEED_HELP_HXNG',
                {
                    from: 'Cart',
                    type: 'pharma',
                    px_id: pxid,
                },
                `I have an issue with creating this Pharma order - for Rx : ${pxid}`,
            );
        }
    };

    const onAutoSuggestMedicineSelect = (
        drug: MedicationsEntity | InjectionsEntity | LabTestsEntityOrProceduresEntity,
    ) => {
        const medicine = drug as MedicationsEntity;
        const newPrescriptionMedications = prescriptionMedications;
        newPrescriptionMedications.push(medicine);
        setIsUpdate(true);
        setIsApplyDiscountLoading(true);
        setPrescriptionMedications(Array.from(newPrescriptionMedications));
        track('AUTO_SUGGEST_MEDICINE_SELECT');
    };

    const onAddFromLastRx = async () => {
        setIsUpdate(true);
        setIsApplyDiscountLoading(true);
        setPrescriptionMedications(Array.from(lastRxMedications));
        track('ADD_FROM_LAST_RX');
    };

    const removeMedicationHandler = (id: string) => {
        const newPrescriptionMedications = prescriptionMedications.filter((i) => i.id !== id);
        if (newPrescriptionMedications.length > 0) {
            setIsUpdate(true);
            setIsApplyDiscountLoading(true);
        }
        setPrescriptionMedications(Array.from(newPrescriptionMedications));
        track('REMOVE_MEDICATION');
    };

    const onRefresh = () => {
        toggleActiveOrder(undefined);
        if (Array.isArray(finishState)) {
            finishState[currentOrderIndex].status = 'cancelled';
            setFinishState(Array.from(finishState));
        }
    };

    const getNumberError = (recipientDetails: RecipientDetails): string => {
        return !checkIfValidPhoneNumber('+91', recipientDetails.mobile)
            ? 'mobile'
            : recipientDetails.alternative_mobile.length > 0 &&
              !checkIfValidPhoneNumber('+91', recipientDetails.alternative_mobile)
            ? 'alternative mobile'
            : '';
    };

    useEffect(() => {
        if (prescriptionMedications.length > 0) {
            pincodeHandler(pincode, prescriptionMedications);
        } else {
            cart.length > 0 && setCart([]);
            removedCart.length > 0 && setRemovedCart([]);
            notAvailableCart.length > 0 && setNotAvailableCart([]);
        }
    }, [prescriptionMedications]);

    const { name: recipientName, mobile, alternative_mobile } = recipientDetails;
    const numberError = getNumberError(recipientDetails);
    const isInvalidPrice = isPriceIsInvalid(cart);

    const MAX_DISCOUNT = response?.in_clinic_max_discount || 0;
    let paymodeArray = Object.entries(paymodeObject);

    if (response?.paymodes?.length) {
        const availablePaymodes = new Set(response.paymodes);
        paymodeArray = paymodeArray.filter((i) => availablePaymodes.has(i[0]));
    }

    if (isForTrialOrder) {
        paymodeArray = [['FREE', 'Free']];
    }

    const isVendorIsOneMg = response?.vendor === ONEMG;
    const ptGender = gender.toUpperCase()[0];

    return (
        <Fragment>
            <div
                className={`relative h-full w-full flex flex-col font-lato font-400 ${
                    !hideBackButton ? 'bg-darwin-neutral-50' : ''
                }`}
            >
                <div className="px-16 py-9 flex items-center justify-between bg-white pad-shadow-v2">
                    <div className="flex items-center space-x-12 cursor-pointer">
                        {!isForTrialOrder && !hideBackButton && (
                            <div
                                onClick={closeMe}
                                className="flex items-center justify-center w-16 h-16"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                    className="w-16 h-16 fill-darwin-neutral-1000"
                                >
                                    <path d="M447.1 256c0 13.25-10.76 24.01-24.01 24.01H83.9l132.7 126.6c9.625 9.156 9.969 24.41 .8125 33.94c-9.156 9.594-24.34 9.938-33.94 .8125l-176-168C2.695 268.9 .0078 262.6 .0078 256S2.695 243.2 7.445 238.6l176-168C193 61.51 208.2 61.85 217.4 71.45c9.156 9.5 8.812 24.75-.8125 33.94l-132.7 126.6h340.1C437.2 232 447.1 242.8 447.1 256z"></path>
                                </svg>
                            </div>
                        )}
                        <p className="text-darwin-neutral-1000 heading-2 bold">
                            {hideBackButton ? 'Medicines Ordered' : 'Order Medicines'}
                        </p>

                        <p className="text-darwin-neutral-800 font-700 text-13 font-700">
                            <span className="font-400">for</span> {name} {age ? ` | ${age}y` : ''}
                            {ptGender ? ` | ${ptGender}` : ''}
                        </p>
                    </div>

                    {isVendorIsOneMg && !finishState?.length && (
                        <div className="flex items-center space-x-8">
                            <p className="font-700 text-darwin-neutral-900">Provided by:</p>
                            <OneMgSvg width="100" height="30" />
                        </div>
                    )}

                    <div className="flex items-center space-x-10">
                        <button
                            className="border border-darwin-primary-500 flex items-center space-x-10 rounded-4 px-12 py-4 font-700"
                            onClick={onNeedHelp}
                        >
                            <p>
                                <svg
                                    className="min-w-16 h-18 fill-darwin-primary-500"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                >
                                    <path d="M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm169.8 53.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" />
                                </svg>
                            </p>
                            <p className="text-darwin-primary-500">
                                {finishState && finishState.length
                                    ? 'Issue with Order?'
                                    : 'Need Help?'}
                            </p>
                        </button>

                        {isForTrialOrder && (
                            <div
                                className="flex items-center cursor-pointer"
                                onClick={exitTrialToggleHandler}
                            >
                                <svg
                                    className="w-14 h-14 fill-darwin-neutral-1000"
                                    viewBox="0 0 12 12"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M10.75 9.71875C11.0312 10.0312 11.0312 10.5 10.75 10.7812C10.4375 11.0938 9.96875 11.0938 9.6875 10.7812L6 7.0625L2.28125 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 1.96875 0.90625 1.5 1.21875 1.21875C1.5 0.90625 1.96875 0.90625 2.25 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.75 1.25C11.0625 1.53125 11.0625 2 10.75 2.3125L7.03125 6L10.75 9.71875Z" />
                                </svg>
                            </div>
                        )}
                    </div>

                    {finishState && finishState.length > 1 && (
                        <div className="absolute w-full flex items-center justify-center">
                            {finishState.map((i, index) => {
                                return (
                                    <p
                                        onClick={() => setCurrentOrderIndex(index)}
                                        className={`cursor-pointer border-b-2 px-14 py-6 ${
                                            currentOrderIndex === index
                                                ? 'text-darwin-primary-500 font-700 border-darwin-primary-500'
                                                : 'border-white'
                                        }`}
                                    >
                                        Medicine Order {index + 1}
                                    </p>
                                );
                            })}
                        </div>
                    )}
                </div>

                {isFetchingOrder && <Loader text="Order" />}

                {isFinish && finishState && finishState.length ? (
                    <Fragment>
                        <OrderDetailsComponent
                            finishState={finishState[currentOrderIndex]}
                            isForTrialOrder={isForTrialOrder}
                        />
                        {isForTrialOrder && (
                            <Fragment>
                                <FinishedPageFooter
                                    type="pharma"
                                    orderDetails={finishState[currentOrderIndex] as OrderDetails}
                                    toggleActiveOrder={toggleActiveOrder}
                                    isForTrialOrder
                                />
                                <ShepherdTour
                                    steps={stepsForFinishState()}
                                    tourOptions={{
                                        exitOnEsc: true,
                                    }}
                                >
                                    <Button />
                                </ShepherdTour>
                            </Fragment>
                        )}
                        {showGoToHEDashboardButton && (
                            <FinishedPageFooter
                                type="pharma"
                                orderDetails={finishState[currentOrderIndex] as OrderDetails}
                                toggleActiveOrder={toggleActiveOrder}
                            />
                        )}
                    </Fragment>
                ) : (
                    <Fragment>
                        <div className="px-16 pt-18 lg:grid grid-cols-5 h-full flex-1 overflow-scroll mt-2 gap-12 space-y-12 lg:space-y-0">
                            {isShow ? (
                                <Fragment>
                                    <div className="space-y-12 col-span-3 overflow-scroll hide-scrollbar lg:pb-84">
                                        {cart.length > 0 && !isVendorIsOneMg && (
                                            <GetDeliveryTypeMainBanner />
                                        )}
                                        {isForQuickCart && (
                                            <Fragment>
                                                <PrescribeAutoSuggestV2
                                                    kind={'Medicines'}
                                                    onSelect={onAutoSuggestMedicineSelect}
                                                    hideCustomEntity
                                                    className="bg-white"
                                                    prescriptionElements={prescriptionMedications}
                                                    isForHXNGFlow={isForQuickCart}
                                                />
                                                {prescriptionMedications.length > 0 && (
                                                    <div className="flex space-x-8 overflow-auto whitespace-nowrap">
                                                        {prescriptionMedications.map((i) => (
                                                            <div className="flex items-center space-x-12 border border-darwin-accent-bright-blue-800 bg-darwin-accent-bright-blue-100 rounded-8 px-12 py-8">
                                                                <p className="text-13 font-700 text-darwin-accent-bright-blue-800">
                                                                    {i.name}
                                                                </p>
                                                                <p
                                                                    className="cursor-pointer"
                                                                    onClick={() =>
                                                                        removeMedicationHandler(
                                                                            i.id,
                                                                        )
                                                                    }
                                                                >
                                                                    <svg
                                                                        className="w-12 h-12"
                                                                        viewBox="0 0 12 12"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M10.7812 2.28125L7.03125 6.03125L10.75 9.75C11.0625 10.0312 11.0625 10.5 10.75 10.7812C10.4688 11.0938 10 11.0938 9.71875 10.7812L5.96875 7.0625L2.25 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 2 0.90625 1.53125 1.21875 1.21875C1.5 0.9375 1.96875 0.9375 2.28125 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.7812 1.25C11.0625 1.53125 11.0625 2 10.7812 2.28125Z"
                                                                            fill="#1A1A1A"
                                                                        />
                                                                    </svg>
                                                                </p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </Fragment>
                                        )}
                                        {cart.length > 0 ? (
                                            <div
                                                className="bg-white rounded-8"
                                                id="items-available"
                                            >
                                                <div className="px-16 py-8 flex items-center justify-between border-b border-darwin-neutral-100">
                                                    <div className="flex items-center space-x-8">
                                                        <div className="flex items-center justify-center w-24 h-24 rounded-4 bg-darwin-accent-green-900">
                                                            <svg
                                                                className="w-14 h-12 fill-white"
                                                                viewBox="0 0 14 11"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path d="M2.875 1.75C2.24219 1.75 1.75 2.26562 1.75 2.875V5.5H4V2.875C4 2.26562 3.48438 1.75 2.875 1.75ZM0.25 2.875C0.25 1.44531 1.42188 0.25 2.875 0.25C4.30469 0.25 5.5 1.44531 5.5 2.875V8.125C5.5 9.57812 4.30469 10.75 2.875 10.75C1.42188 10.75 0.25 9.57812 0.25 8.125V2.875ZM13.2344 8.875C13.0703 9.15625 12.6953 9.17969 12.4609 8.94531L8.05469 4.53906C7.82031 4.30469 7.84375 3.92969 8.125 3.76562C8.6875 3.4375 9.32031 3.25 10 3.25C12.0625 3.25 13.75 4.9375 13.75 7C13.75 7.67969 13.5625 8.3125 13.2344 8.875ZM11.8516 10.2578C11.3125 10.5859 10.6562 10.75 10 10.75C7.91406 10.75 6.25 9.08594 6.25 7C6.25 6.34375 6.41406 5.6875 6.74219 5.14844C6.90625 4.86719 7.28125 4.84375 7.51562 5.07812L11.9219 9.48438C12.1562 9.71875 12.1328 10.0938 11.8516 10.2578Z" />
                                                            </svg>
                                                        </div>
                                                        <p className="text-14 font-700">
                                                            Items Available ({cart.length})
                                                        </p>
                                                    </div>

                                                    <p className="text-13 text-darwin-neutral-800">
                                                        Quantity is based on the Rx
                                                    </p>
                                                </div>

                                                <div>
                                                    {cart.map((medicine, index) => (
                                                        <div
                                                            className={`flex items-start space-x-16 p-16 ${
                                                                index + 1 !== cart.length
                                                                    ? 'border-b'
                                                                    : ''
                                                            } border-darwin-neutral-100`}
                                                        >
                                                            <div className="flex-1">
                                                                <p className="text-14 font-700 space-x-6">
                                                                    <span>{medicine.name}</span>
                                                                    {medicine.is_otc && (
                                                                        <AntTooltip
                                                                            content={
                                                                                medicine.discount_allowed
                                                                                    ? 'This is OTC drug'
                                                                                    : 'No discount on this drug'
                                                                            }
                                                                        >
                                                                            <span className="cursor-pointer text-11 bg-darwin-accent-diagnosis-purple-100 text-darwin-accent-diagnosis-purple-800 border border-darwin-accent-diagnosis-purple-800 px-6 py-2 rounded-4">
                                                                                OTC
                                                                            </span>
                                                                        </AntTooltip>
                                                                    )}
                                                                </p>
                                                                <p className="text-13 text-darwin-neutral-700 mt-2">
                                                                    {medicine.generic_name}
                                                                </p>
                                                                <p className="text-14 mt-8 mb-16">
                                                                    {medicine.manufacturer_name}
                                                                </p>
                                                                <p
                                                                    className={`text-13 text-darwin-status-warning-500 font-700 cursor-pointer w-max ${
                                                                        isForTrialOrder
                                                                            ? 'pointer-events-none opacity-70'
                                                                            : ''
                                                                    }`}
                                                                    onClick={() =>
                                                                        removeFromCart(
                                                                            medicine.eka_id,
                                                                        )
                                                                    }
                                                                >
                                                                    Remove
                                                                </p>
                                                            </div>

                                                            <div className="select-none">
                                                                {medicine.isInvalidPrice ? (
                                                                    <p className="flex items-center space-x-6 whitespace-nowrap text-right font-700">
                                                                        <UnavailablePriceFAQsIcon />
                                                                        <span>
                                                                            Price available at
                                                                            dispatch
                                                                        </span>
                                                                    </p>
                                                                ) : (
                                                                    <p className="text-14 font-700 text-right whitespace-nowrap">
                                                                        <Discount
                                                                            medicine={medicine}
                                                                        />{' '}
                                                                        {medicine.totalamount !==
                                                                        medicine.mrp ? (
                                                                            <span className="pr-2 text-13 line-through text-darwin-neutral-700 opacity-80">
                                                                                ₹
                                                                                {medicine.mrp?.toFixed(
                                                                                    2,
                                                                                )}
                                                                            </span>
                                                                        ) : (
                                                                            'MRP:'
                                                                        )}{' '}
                                                                        ₹
                                                                        {medicine.totalamount?.toFixed(
                                                                            2,
                                                                        )}
                                                                    </p>
                                                                )}
                                                                <p className="text-13 text-darwin-neutral-700 text-right">
                                                                    {medicine.qty} x{' '}
                                                                    {medicine.product_sku}
                                                                </p>
                                                                <QuantityComponent
                                                                    medicine={medicine}
                                                                    cartHandler={cartHandler}
                                                                    isForTrialOrder={Boolean(
                                                                        isForTrialOrder,
                                                                    )}
                                                                />
                                                                {!medicine.discount_allowed && (
                                                                    <div className="flex justify-end">
                                                                        <p className="mt-10 w-max font-700 text-12 bg-darwin-status-warning-100 text-darwin-status-warning-500 border border-darwin-status-warning-500 px-6 py-2 rounded-4">
                                                                            No discount applicable
                                                                        </p>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ) : isForQuickCart ? (
                                            <div className="flex flex-col items-center space-y-12 flex-1 overflow-hidden pt-10">
                                                <p>
                                                    <svg
                                                        className="w-12 h-8 fill-darwin-neutrals-600"
                                                        viewBox="0 0 12 8"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M6.6875 1.3125L10.6875 5.3125C10.9688 5.59375 11.0625 6.03125 10.9062 6.40625C10.75 6.78125 10.375 7.03125 10 7.03125H2C1.59375 7.03125 1.21875 6.78125 1.0625 6.40625C0.90625 6.03125 1 5.59375 1.28125 5.3125L5.28125 1.3125C5.65625 0.90625 6.3125 0.90625 6.6875 1.3125Z" />
                                                    </svg>
                                                </p>
                                                <p className="text-13 text-darwin-neutrals-600">
                                                    Search for medicine to add to cart
                                                </p>
                                                {prescriptionMedications.length === 0 && (
                                                    <Fragment>
                                                        <p className="text-13 text-darwin-neutrals-600">
                                                            Or
                                                        </p>
                                                        <button
                                                            className="flex items-center space-x-8 px-12 py-8 rounded-8 text-white bg-darwin-accent-bright-blue-800 font-700 text-13 disabled:opacity-70"
                                                            onClick={onAddFromLastRx}
                                                            disabled={
                                                                isFetchingLastRx ||
                                                                !lastRxMedications ||
                                                                lastRxMedications.length === 0
                                                            }
                                                        >
                                                            {isFetchingLastRx ? (
                                                                <svg
                                                                    className="w-16 h-16 fill-white animate-spin"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 512 512"
                                                                >
                                                                    <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                                                                </svg>
                                                            ) : lastRxMedications &&
                                                              lastRxMedications.length > 0 ? (
                                                                <svg
                                                                    className="w-16 h-16 fill-white"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 448 512"
                                                                >
                                                                    <path d="M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z"></path>
                                                                </svg>
                                                            ) : null}
                                                            <p>
                                                                {isFetchingLastRx ||
                                                                (lastRxMedications &&
                                                                    lastRxMedications.length > 0)
                                                                    ? 'Add from last Rx'
                                                                    : 'No Past Visits Found'}
                                                            </p>
                                                        </button>
                                                    </Fragment>
                                                )}
                                            </div>
                                        ) : null}

                                        {removedCart.length !== 0 && (
                                            <div className="bg-white rounded-8 pb-16">
                                                <div className="px-16 py-8 flex items-center justify-between border-b border-darwin-neutral-100">
                                                    <div className="flex items-center space-x-8">
                                                        <div className="flex items-center justify-center w-24 h-24 rounded-4 bg-darwin-accent-bright-yellow-800">
                                                            <svg
                                                                className="w-14 h-12 fill-white"
                                                                viewBox="0 0 14 11"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path d="M2.875 1.75C2.24219 1.75 1.75 2.26562 1.75 2.875V5.5H4V2.875C4 2.26562 3.48438 1.75 2.875 1.75ZM0.25 2.875C0.25 1.44531 1.42188 0.25 2.875 0.25C4.30469 0.25 5.5 1.44531 5.5 2.875V8.125C5.5 9.57812 4.30469 10.75 2.875 10.75C1.42188 10.75 0.25 9.57812 0.25 8.125V2.875ZM13.2344 8.875C13.0703 9.15625 12.6953 9.17969 12.4609 8.94531L8.05469 4.53906C7.82031 4.30469 7.84375 3.92969 8.125 3.76562C8.6875 3.4375 9.32031 3.25 10 3.25C12.0625 3.25 13.75 4.9375 13.75 7C13.75 7.67969 13.5625 8.3125 13.2344 8.875ZM11.8516 10.2578C11.3125 10.5859 10.6562 10.75 10 10.75C7.91406 10.75 6.25 9.08594 6.25 7C6.25 6.34375 6.41406 5.6875 6.74219 5.14844C6.90625 4.86719 7.28125 4.84375 7.51562 5.07812L11.9219 9.48438C12.1562 9.71875 12.1328 10.0938 11.8516 10.2578Z" />
                                                            </svg>
                                                        </div>
                                                        <p className="text-14 font-700">
                                                            Items Removed ({removedCart.length})
                                                        </p>
                                                    </div>
                                                </div>
                                                {removedCart.map((i) => (
                                                    <div className="flex items-center justify-between bg-darwin-accent-bright-yellow-200 rounded-8 px-16 py-8 m-16 mb-0">
                                                        <div>
                                                            <p className="font-700 text-14">
                                                                {i.name}
                                                            </p>
                                                            <p className="text-13 text-darwin-neutral-700">
                                                                {i.generic_name}
                                                            </p>
                                                        </div>

                                                        <p
                                                            className="text-14 font-700 text-darwin-primary-500 cursor-pointer"
                                                            onClick={() => addToCart(i.eka_id)}
                                                        >
                                                            Add to cart
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        {notAvailableCart.length !== 0 && (
                                            <div className="bg-white rounded-8 pb-16">
                                                <div className="px-16 py-8 flex items-center justify-between border-b border-darwin-neutral-100">
                                                    <div className="flex items-center space-x-8">
                                                        <div className="flex items-center justify-center w-24 h-24 rounded-4 bg-darwin-status-warning-500">
                                                            <svg
                                                                className="w-14 h-12 fill-white"
                                                                viewBox="0 0 14 11"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path d="M2.875 1.75C2.24219 1.75 1.75 2.26562 1.75 2.875V5.5H4V2.875C4 2.26562 3.48438 1.75 2.875 1.75ZM0.25 2.875C0.25 1.44531 1.42188 0.25 2.875 0.25C4.30469 0.25 5.5 1.44531 5.5 2.875V8.125C5.5 9.57812 4.30469 10.75 2.875 10.75C1.42188 10.75 0.25 9.57812 0.25 8.125V2.875ZM13.2344 8.875C13.0703 9.15625 12.6953 9.17969 12.4609 8.94531L8.05469 4.53906C7.82031 4.30469 7.84375 3.92969 8.125 3.76562C8.6875 3.4375 9.32031 3.25 10 3.25C12.0625 3.25 13.75 4.9375 13.75 7C13.75 7.67969 13.5625 8.3125 13.2344 8.875ZM11.8516 10.2578C11.3125 10.5859 10.6562 10.75 10 10.75C7.91406 10.75 6.25 9.08594 6.25 7C6.25 6.34375 6.41406 5.6875 6.74219 5.14844C6.90625 4.86719 7.28125 4.84375 7.51562 5.07812L11.9219 9.48438C12.1562 9.71875 12.1328 10.0938 11.8516 10.2578Z" />
                                                            </svg>
                                                        </div>
                                                        <p className="text-14 font-700">
                                                            Items Not Available (
                                                            {notAvailableCart.length})
                                                        </p>
                                                    </div>
                                                </div>
                                                {notAvailableCart.map((i) => (
                                                    <div className="flex items-center justify-between px-16 m-16 rounded-8 bg-darwin-status-warning-100 mb-0">
                                                        <div className="py-8 flex items-center justify-between">
                                                            <div>
                                                                <p className="text-14 font-700">
                                                                    {i.name}
                                                                </p>
                                                                <p className="text-13 text-darwin-neutral-700">
                                                                    {i.generic_name}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <p className="capitalize text-darwin-primary-500 font-700 whitespace-nowrap">
                                                            {i.status?.replaceAll?.('_', ' ')}
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    <div className="space-y-12 col-span-2 overflow-scroll hide-scrollbar pb-144">
                                        <div className="relative">
                                            {MAX_DISCOUNT !== 0 && (
                                                <div
                                                    className="bg-white rounded-8 pb-16"
                                                    id="apply-discount"
                                                >
                                                    <div className="px-16 py-8 flex items-center justify-between border-b border-darwin-neutral-100">
                                                        <div className="flex items-center space-x-8">
                                                            <div className="flex items-center justify-center w-24 h-24 rounded-4 bg-darwin-accent-burgandy-800">
                                                                <svg
                                                                    className="w-11 h-12 fill-white"
                                                                    viewBox="0 0 11 11"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path d="M0.25 1.375V4.89062C0.25 5.28906 0.390625 5.66406 0.671875 5.94531L4.79688 10.0703C5.38281 10.6562 6.34375 10.6562 6.92969 10.0703L10.0469 6.95312C10.6328 6.36719 10.6328 5.40625 10.0469 4.82031L5.92188 0.695312C5.64062 0.414062 5.26562 0.273438 4.86719 0.273438H1.375C0.742188 0.25 0.25 0.765625 0.25 1.375ZM2.875 3.625C2.45312 3.625 2.125 3.29688 2.125 2.875C2.125 2.47656 2.45312 2.125 2.875 2.125C3.27344 2.125 3.625 2.47656 3.625 2.875C3.625 3.29688 3.27344 3.625 2.875 3.625Z" />
                                                                </svg>
                                                            </div>
                                                            <p className="text-14 font-700">
                                                                Discount
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div className="space-y-12 p-16 pb-0">
                                                        <p className="text-14">
                                                            Enter discount percentage
                                                        </p>

                                                        <div className="space-y-6">
                                                            <div className="flex items-center space-x-8 text-14">
                                                                <div className="p-10 border border-darwin-neutral-200 rounded-8 flex items-center space-x-8">
                                                                    <input
                                                                        type="number"
                                                                        placeholder="000"
                                                                        className="w-64"
                                                                        value={discountInp}
                                                                        onChange={(e) =>
                                                                            setDiscountInp(
                                                                                e.target.value,
                                                                            )
                                                                        }
                                                                    />
                                                                    {isApplyDiscountLoading ? (
                                                                        <svg
                                                                            className="w-12 h-12 fill-darwin-neutral-700 animate-spin"
                                                                            role="img"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            viewBox="0 0 512 512"
                                                                        >
                                                                            <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                                                                        </svg>
                                                                    ) : (
                                                                        <svg
                                                                            className="w-12 h-12 fill-darwin-neutral-700"
                                                                            viewBox="0 0 12 11"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path d="M11.0312 0.71875C10.7578 0.445312 10.3477 0.445312 10.1016 0.71875L0.914062 9.90625C0.640625 10.1523 0.640625 10.5625 0.914062 10.8086C1.05078 10.9453 1.21484 11 1.40625 11C1.57031 11 1.73438 10.9453 1.84375 10.8086L11.0312 1.62109C11.3047 1.375 11.3047 0.964844 11.0312 0.71875ZM2.5 3.5625C3.21094 3.5625 3.8125 2.98828 3.8125 2.25C3.8125 1.53906 3.21094 0.9375 2.5 0.9375C1.76172 0.9375 1.1875 1.53906 1.1875 2.25C1.1875 2.98828 1.76172 3.5625 2.5 3.5625ZM9.5 7.9375C8.76172 7.9375 8.1875 8.53906 8.1875 9.25C8.1875 9.98828 8.76172 10.5625 9.5 10.5625C10.2109 10.5625 10.8125 9.98828 10.8125 9.25C10.8125 8.53906 10.2109 7.9375 9.5 7.9375Z" />
                                                                        </svg>
                                                                    )}
                                                                </div>
                                                                <button
                                                                    className="space-x-8 p-10 px-16 bg-darwin-primary-500 rounded-8 text-white font-700"
                                                                    onClick={() =>
                                                                        updateCartHandler(pincode)
                                                                    }
                                                                >
                                                                    {discountInp === discount &&
                                                                    Number(discount) ? (
                                                                        <Fragment>
                                                                            <span>✓</span>
                                                                            <span>Applied</span>
                                                                        </Fragment>
                                                                    ) : (
                                                                        'Apply'
                                                                    )}
                                                                </button>
                                                            </div>
                                                            {discountInp === discount &&
                                                                Number(discount) > 0 && (
                                                                    <p className="text-13 text-darwin-accent-green-900 relative top-4">
                                                                        Discount applied on certain
                                                                        drugs ✅.
                                                                    </p>
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <div
                                                className={`rounded-8 pb-16 ${
                                                    isInvalidPrice
                                                        ? 'bg-darwin-accent-bright-yellow-200 border border-darwin-accent-bright-yellow-800'
                                                        : 'bg-white'
                                                } ${MAX_DISCOUNT !== 0 ? 'mt-12' : ''}`}
                                            >
                                                <div className="px-16 py-8 flex items-center justify-between border-b border-darwin-neutral-100">
                                                    <div className="flex items-center space-x-8">
                                                        <div
                                                            className={`flex items-center justify-center w-24 h-24 rounded-4 ${
                                                                isInvalidPrice
                                                                    ? 'bg-darwin-accent-examination-findings-sky-blue-800'
                                                                    : 'bg-darwin-primary-500'
                                                            }`}
                                                        >
                                                            <svg
                                                                className="w-8 h-12 fill-white"
                                                                viewBox="0 0 8 11"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path d="M0.25 1C0.25 0.601562 0.578125 0.25 1 0.25H2.5H2.875H7C7.39844 0.25 7.75 0.601562 7.75 1C7.75 1.42188 7.39844 1.75 7 1.75H5.66406C5.89844 2.10156 6.0625 2.47656 6.15625 2.875H7C7.39844 2.875 7.75 3.22656 7.75 3.625C7.75 4.04688 7.39844 4.375 7 4.375H6.15625C5.85156 5.75781 4.70312 6.8125 3.29688 6.97656L6.67188 9.39062C7.02344 9.64844 7.09375 10.1172 6.85938 10.4453C6.60156 10.7734 6.13281 10.8672 5.80469 10.6094L0.554688 6.85938C0.296875 6.67188 0.179688 6.34375 0.273438 6.03906C0.367188 5.71094 0.671875 5.5 1 5.5H2.875C3.625 5.5 4.30469 5.05469 4.58594 4.375H1C0.578125 4.375 0.25 4.04688 0.25 3.625C0.25 3.22656 0.578125 2.875 1 2.875H4.58594C4.30469 2.21875 3.625 1.75 2.875 1.75H2.5H1C0.578125 1.75 0.25 1.42188 0.25 1Z" />
                                                            </svg>
                                                        </div>
                                                        <p className="text-14 font-700">
                                                            Amount to be Paid
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="space-y-16 p-16 pb-0">
                                                    {cart.length === 0 && isForQuickCart ? (
                                                        <div className="flex flex-col items-center space-y-12 px-16 pt-24 pb-16">
                                                            <svg
                                                                className="w-26 h-26 fill-darwin-neutrals-600"
                                                                viewBox="0 0 25 25"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path d="M15.4219 1.32812L16.9219 2.82812L22.125 8.07812L23.625 9.57812C24.0938 10.0469 24.0938 10.75 23.625 11.1719C23.2031 11.6406 22.5 11.6406 22.0781 11.1719L21.375 10.4688L8.25 23.5938C7.3125 24.5312 6.09375 25 4.82812 25C2.15625 25 0 22.8438 0 20.1719C0 18.9062 0.46875 17.6875 1.40625 16.75L14.5312 3.625L13.8281 2.92188C13.3594 2.5 13.3594 1.79688 13.8281 1.32812C14.25 0.90625 14.9531 0.90625 15.4219 1.32812ZM8.34375 13H8.29688H15.6562L19.7812 8.875L16.125 5.21875L8.34375 13Z" />
                                                            </svg>
                                                            <p className="text-13 text-darwin-neutrals-600">
                                                                Add medicines to your cart to place
                                                                the order
                                                            </p>
                                                        </div>
                                                    ) : isInvalidPrice ? (
                                                        <div className="flex space-x-8">
                                                            <span>
                                                                <svg
                                                                    className="w-16 h-16 fill-darwin-accent-bright-yellow-800 mt-3"
                                                                    viewBox="0 0 16 16"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path d="M8 16C3.5625 16 0 12.4375 0 8C0 3.59375 3.5625 0 8 0C12.4062 0 16 3.59375 16 8C16 12.4375 12.4062 16 8 16ZM6.75 10.5C6.3125 10.5 6 10.8438 6 11.25C6 11.6875 6.3125 12 6.75 12H9.25C9.65625 12 10 11.6875 10 11.25C10 10.8438 9.65625 10.5 9.25 10.5H9V7.75C9 7.34375 8.65625 7 8.25 7H6.75C6.3125 7 6 7.34375 6 7.75C6 8.1875 6.3125 8.5 6.75 8.5H7.5V10.5H6.75ZM8 6C8.53125 6 9 5.5625 9 5C9 4.46875 8.53125 4 8 4C7.4375 4 7 4.46875 7 5C7 5.5625 7.4375 6 8 6Z" />
                                                                </svg>
                                                            </span>

                                                            <p>
                                                                Available at dispatch. You can
                                                                continue placing the order.{' '}
                                                                <span
                                                                    className="font-700 text-darwin-primary-500 cursor-pointer"
                                                                    onClick={showFAQsHandler}
                                                                >
                                                                    Learn more
                                                                </span>
                                                            </p>
                                                        </div>
                                                    ) : (
                                                        <Fragment>
                                                            <div className="text-14 space-y-8">
                                                                <div className="flex items-center justify-between">
                                                                    <p>Total MRP</p>
                                                                    {isInvalidPrice ? (
                                                                        <p className="flex items-center space-x-6 whitespace-nowrap text-right">
                                                                            <UnavailablePriceFAQsIcon />
                                                                            <span>
                                                                                Price available at
                                                                                dispatch
                                                                            </span>
                                                                        </p>
                                                                    ) : (
                                                                        <p>
                                                                            ₹{' '}
                                                                            {response?.totalMRP?.toFixed(
                                                                                2,
                                                                            )}
                                                                        </p>
                                                                    )}
                                                                </div>

                                                                <div className="flex items-center justify-between">
                                                                    <p>Absolute Discount</p>
                                                                    <p className="text-darwin-accent-green-900">
                                                                        - ₹{' '}
                                                                        {response?.absoluteDiscount?.toFixed(
                                                                            2,
                                                                        )}
                                                                    </p>
                                                                </div>

                                                                <div className="flex items-center justify-between">
                                                                    <p>Discounted Price</p>
                                                                    {isInvalidPrice ? (
                                                                        <p className="flex items-center space-x-6 whitespace-nowrap text-right">
                                                                            <UnavailablePriceFAQsIcon />
                                                                            <span>
                                                                                Price available at
                                                                                dispatch
                                                                            </span>
                                                                        </p>
                                                                    ) : (
                                                                        <p>
                                                                            ₹{' '}
                                                                            {response?.discountedPrice?.toFixed(
                                                                                2,
                                                                            )}
                                                                        </p>
                                                                    )}
                                                                </div>

                                                                <ExtraChargesList
                                                                    extra_charges={
                                                                        response?.extra_charges
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="h-1 bg-darwin-neutral-100"></div>
                                                            <div className="flex items-center justify-between text-18 font-700">
                                                                <p>Total Amount</p>
                                                                {isInvalidPrice ? (
                                                                    <p className="flex items-center space-x-6 whitespace-nowrap text-right">
                                                                        <UnavailablePriceFAQsIcon />
                                                                        <span>
                                                                            Price available at
                                                                            dispatch
                                                                        </span>
                                                                    </p>
                                                                ) : (
                                                                    <p
                                                                        className={`relative ${
                                                                            Number(
                                                                                response?.discount,
                                                                            ) > 0
                                                                                ? 'pb-12'
                                                                                : ''
                                                                        }`}
                                                                    >
                                                                        ₹{' '}
                                                                        {response?.totalAmount?.toFixed(
                                                                            2,
                                                                        )}
                                                                        {Number(
                                                                            response?.discount,
                                                                        ) > 0 && (
                                                                            <span className="whitespace-nowrap absolute right-0 -bottom-10 text-13 font-700 text-darwin-accent-green-900">
                                                                                (
                                                                                {response?.discount}
                                                                                % OFF)
                                                                            </span>
                                                                        )}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </Fragment>
                                                    )}
                                                </div>
                                            </div>

                                            {(cart.length && isUpdate && (
                                                <div
                                                    className="absolute h-full top-0 right-0 bottom-0 left-0 flex flex-col items-center justify-center rounded-8"
                                                    style={{
                                                        background: 'rgba(255, 236, 254, 0.7)',
                                                        boxShadow:
                                                            '0px 2px 8px rgba(0, 0, 0, 0.12)',
                                                        backdropFilter: 'blur(4px)',
                                                    }}
                                                >
                                                    <p className="text-18 font-700">
                                                        Few items have been changed in your cart
                                                    </p>
                                                    <p className="text-14 mt-8 mb-14">
                                                        Update to view prices & availability
                                                    </p>
                                                    <button
                                                        className="flex items-center space-x-8 border border-white rounded-8 p-9 px-16 bg-darwin-primary-500 text-white"
                                                        onClick={() => updateCartHandler(pincode)}
                                                    >
                                                        {isApplyDiscountLoading ? (
                                                            <svg
                                                                className="w-16 h-16 fill-white animate-spin"
                                                                role="img"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 512 512"
                                                            >
                                                                <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                                                            </svg>
                                                        ) : (
                                                            <svg
                                                                className="w-16 h-16 fill-white"
                                                                viewBox="0 0 16 16"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path d="M3.28125 6.34375C3.5 5.65625 3.90625 5.03125 4.4375 4.46875C6.40625 2.53125 9.5625 2.53125 11.5312 4.46875L12.0625 5H10.5C9.9375 5 9.5 5.46875 9.5 6C9.5 6.5625 9.9375 7 10.5 7H14.4688C15.0312 7 15.4688 6.5625 15.4688 6V2C15.4688 1.46875 15.0312 1 14.4688 1C13.9375 1 13.4688 1.46875 13.4688 2V3.625L12.9375 3.0625C10.1875 0.34375 5.78125 0.34375 3.03125 3.0625C2.28125 3.8125 1.71875 4.71875 1.375 5.6875C1.1875 6.21875 1.46875 6.78125 2 6.96875C2.5 7.15625 3.09375 6.875 3.28125 6.34375ZM1.21875 9.0625C1.0625 9.09375 0.90625 9.1875 0.78125 9.3125C0.65625 9.4375 0.5625 9.59375 0.53125 9.75C0.5 9.78125 0.5 9.8125 0.5 9.875C0.5 9.90625 0.5 9.96875 0.5 10.0312V14C0.5 14.5625 0.9375 15 1.5 15C2.03125 15 2.5 14.5625 2.5 14V12.4062L3.03125 12.9688C5.78125 15.6875 10.1875 15.6875 12.9375 12.9688C13.6875 12.1875 14.25 11.3125 14.5938 10.3438C14.7812 9.8125 14.5 9.25 13.9688 9.0625C13.4688 8.875 12.875 9.15625 12.6875 9.6875C12.4688 10.375 12.0625 11 11.5312 11.5625C9.5625 13.5 6.40625 13.5 4.4375 11.5625L3.90625 11H5.5C6.03125 11 6.5 10.5625 6.5 10C6.5 9.46875 6.03125 9 5.5 9H1.5C1.4375 9 1.40625 9.03125 1.34375 9.03125C1.3125 9.03125 1.25 9.03125 1.21875 9.0625Z" />
                                                            </svg>
                                                        )}
                                                        <span className="text-14 font-700">
                                                            Update cart
                                                        </span>
                                                    </button>
                                                </div>
                                            )) ||
                                                ''}
                                        </div>
                                        <div className="bg-white rounded-8" id="add-address">
                                            <div className="px-16 py-8 flex items-center justify-between border-b border-darwin-neutral-100">
                                                <div className="flex items-center space-x-8">
                                                    <div className="flex items-center justify-center w-24 h-24 rounded-4 bg-darwin-accent-medical-history-orange-800">
                                                        <svg
                                                            className="w-9 h-12 fill-white"
                                                            viewBox="0 0 9 13"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path d="M5.03906 12.2188C6.25781 10.6953 9 7.0625 9 5C9 2.51562 6.98438 0.5 4.5 0.5C2.01562 0.5 0 2.51562 0 5C0 7.0625 2.74219 10.6953 3.9375 12.2188C4.21875 12.5703 4.75781 12.5703 5.03906 12.2188ZM4.5 6.5C3.65625 6.5 3 5.84375 3 5C3 4.17969 3.65625 3.5 4.5 3.5C5.32031 3.5 6 4.17969 6 5C6 5.84375 5.32031 6.5 4.5 6.5Z" />
                                                        </svg>
                                                    </div>
                                                    <p className="text-14 font-700">
                                                        Delivery Address
                                                    </p>
                                                </div>
                                            </div>

                                            {showFilledAddress ? (
                                                <div className="p-16">
                                                    {cart.length > 0 && !isVendorIsOneMg && (
                                                        <GetDeliveryTypeSecondaryBanner />
                                                    )}
                                                    <div className="border-b border-darwin-neutral-100 pb-10 mb-10 text-14 space-y-12">
                                                        <div className="flex items-start space-x-12">
                                                            <div className="flex-1">
                                                                {[
                                                                    formInput.line,
                                                                    formInput.landmark,
                                                                    formInput.city,
                                                                    formInput.state,
                                                                    pincode,
                                                                ]
                                                                    .filter(Boolean)
                                                                    .join(', ')}
                                                                .
                                                            </div>
                                                            <svg
                                                                className="w-14 h-13 fill-darwin-neutral-900 mt-3 cursor-pointer"
                                                                viewBox="0 0 14 13"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                onClick={() => {
                                                                    setShowAddAddress(true);
                                                                    setIsNewAddress(false);
                                                                    setShowForm(true);
                                                                    track(
                                                                        'ORDER_MEDICINE_ADDRESS_BOTTOM_BUTTON',
                                                                        {
                                                                            pxId: pxid,
                                                                        },
                                                                    );
                                                                }}
                                                            >
                                                                <path d="M1.84375 8.96094C1.9375 8.63281 2.125 8.32812 2.35938 8.09375L9.48438 0.96875C10.0703 0.382812 11.0312 0.382812 11.6172 0.96875L12.5312 1.88281C12.6016 1.95312 12.6719 2.04688 12.7188 2.11719C13.1172 2.70312 13.0469 3.5 12.5312 4.01562L5.40625 11.1406C5.38281 11.1641 5.33594 11.1875 5.3125 11.2344C5.07812 11.4219 4.82031 11.5625 4.53906 11.6562L1.70312 12.4766C1.51562 12.5469 1.30469 12.5 1.16406 12.3359C1 12.1953 0.953125 11.9844 1 11.7969L1.84375 8.96094ZM2.38281 11.1172L4.21094 10.5781C4.25781 10.5547 4.32812 10.5312 4.375 10.5078L3.53125 10.3438C3.34375 10.2969 3.17969 10.1562 3.15625 9.96875L2.99219 9.125C2.96875 9.17188 2.94531 9.24219 2.92188 9.28906L2.38281 11.1172ZM5.21875 9.73438L9.97656 4.97656L8.5 3.52344L3.76562 8.28125L4 9.47656L5.21875 9.73438Z" />
                                                            </svg>
                                                        </div>
                                                        <DeliveryETA
                                                            eta={response?.eta}
                                                            eta_display={response?.eta_display}
                                                        />
                                                    </div>

                                                    <div className="font-700 text-darwin-primary-500">
                                                        {patientAddressArray?.length > 1 ? (
                                                            <div
                                                                className="flex items-center space-x-8 cursor-pointer"
                                                                onClick={() => {
                                                                    setShowAddAddress(true);
                                                                    setShowForm(false);
                                                                }}
                                                            >
                                                                <p>
                                                                    {patientAddressArray.length - 1}{' '}
                                                                    more
                                                                </p>
                                                                <svg
                                                                    className="w-9 h-12 fill-darwin-primary-500"
                                                                    viewBox="0 0 7 11"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path d="M6.01562 4.98438C6.32031 5.26562 6.32031 5.75781 6.01562 6.03906L1.51562 10.5391C1.23438 10.8438 0.742188 10.8438 0.460938 10.5391C0.15625 10.2578 0.15625 9.76562 0.460938 9.48438L4.42188 5.5L0.460938 1.53906C0.15625 1.25781 0.15625 0.765625 0.460938 0.484375C0.742188 0.179688 1.23438 0.179688 1.51562 0.484375L6.01562 4.98438Z" />
                                                                </svg>
                                                            </div>
                                                        ) : (
                                                            <div
                                                                className="flex items-center space-x-8 cursor-pointer"
                                                                onClick={() => {
                                                                    setShowAddAddress(true);
                                                                    setIsNewAddress(true);
                                                                    track(
                                                                        'ORDER_MEDICINE_ADDRESS_BOTTOM_BUTTON',
                                                                        {
                                                                            pxId: pxid,
                                                                        },
                                                                    );
                                                                }}
                                                            >
                                                                <svg
                                                                    className="w-12 h-12 fill-darwin-primary-500"
                                                                    viewBox="0 0 11 11"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path d="M6.25 1.375C6.25 0.976562 5.89844 0.625 5.5 0.625C5.07812 0.625 4.75 0.976562 4.75 1.375V4.75H1.375C0.953125 4.75 0.625 5.10156 0.625 5.5C0.625 5.92188 0.953125 6.25 1.375 6.25H4.75V9.625C4.75 10.0469 5.07812 10.375 5.5 10.375C5.89844 10.375 6.25 10.0469 6.25 9.625V6.25H9.625C10.0234 6.25 10.375 5.92188 10.375 5.5C10.375 5.10156 10.0234 4.75 9.625 4.75H6.25V1.375Z" />
                                                                </svg>
                                                                <p>Add new address</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="px-16 grid place-items-center pb-16">
                                                    <DeliveryAddressMapSVG />
                                                    <button
                                                        className="btn--small primary-btn px-16 py-8"
                                                        onClick={() => {
                                                            setShowAddAddress(true);
                                                            track(
                                                                'ORDER_MEDICINE_ADDRESS_TOP_BUTTON',
                                                                {
                                                                    pxId: pxid,
                                                                },
                                                            );
                                                            setIsNewAddress(false);
                                                        }}
                                                    >
                                                        Add Address
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                        {showFilledAddress && (
                                            <div className="bg-white rounded-8">
                                                <div className="px-16 py-8 flex items-center justify-between border-b border-darwin-neutral-100">
                                                    <div className="flex items-center space-x-8">
                                                        <div className="flex items-center justify-center w-24 h-24 rounded-4 bg-darwin-accent-bright-yellow-800">
                                                            <svg
                                                                className="w-13 h-13 fill-white"
                                                                viewBox="0 0 13 13"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path d="M3.84375 1.08594C3.67969 0.640625 3.1875 0.429688 2.74219 0.546875L0.679688 1.10938C0.28125 1.22656 0 1.57812 0 2C0 7.8125 4.6875 12.5 10.5 12.5C10.9219 12.5 11.2734 12.2188 11.3906 11.8203L11.9531 9.75781C12.0703 9.3125 11.8594 8.82031 11.4141 8.65625L9.16406 7.71875C8.78906 7.55469 8.34375 7.64844 8.08594 7.97656L7.125 9.125C5.48438 8.35156 4.14844 7.01562 3.375 5.375L4.52344 4.41406C4.85156 4.15625 4.94531 3.71094 4.78125 3.33594L3.84375 1.08594Z" />
                                                            </svg>
                                                        </div>
                                                        <p className="text-14 font-700">
                                                            Recipient Contact
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="flex items-start p-16 space-x-12">
                                                    <div className="flex-1 space-y-4">
                                                        <p className="font-700">{recipientName}</p>
                                                        <p className="flex flex-wrap gap-x-8">
                                                            <p>+91 {mobile}</p>
                                                            {alternative_mobile.length !== 0 && (
                                                                <p>
                                                                    (Alt: +91 {alternative_mobile})
                                                                </p>
                                                            )}
                                                        </p>
                                                    </div>
                                                    <svg
                                                        className="w-14 h-13 fill-darwin-neutral-900 mt-3 cursor-pointer"
                                                        viewBox="0 0 14 13"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        onClick={() => {
                                                            setShowAddRecipient(true);
                                                            track(
                                                                'ORDER_MEDICINE_RECIPIENT_DETAILS_CHANGED',
                                                                {
                                                                    pxId: pxid,
                                                                },
                                                            );
                                                        }}
                                                    >
                                                        <path d="M1.84375 8.96094C1.9375 8.63281 2.125 8.32812 2.35938 8.09375L9.48438 0.96875C10.0703 0.382812 11.0312 0.382812 11.6172 0.96875L12.5312 1.88281C12.6016 1.95312 12.6719 2.04688 12.7188 2.11719C13.1172 2.70312 13.0469 3.5 12.5312 4.01562L5.40625 11.1406C5.38281 11.1641 5.33594 11.1875 5.3125 11.2344C5.07812 11.4219 4.82031 11.5625 4.53906 11.6562L1.70312 12.4766C1.51562 12.5469 1.30469 12.5 1.16406 12.3359C1 12.1953 0.953125 11.9844 1 11.7969L1.84375 8.96094ZM2.38281 11.1172L4.21094 10.5781C4.25781 10.5547 4.32812 10.5312 4.375 10.5078L3.53125 10.3438C3.34375 10.2969 3.17969 10.1562 3.15625 9.96875L2.99219 9.125C2.96875 9.17188 2.94531 9.24219 2.92188 9.28906L2.38281 11.1172ZM5.21875 9.73438L9.97656 4.97656L8.5 3.52344L3.76562 8.28125L4 9.47656L5.21875 9.73438Z" />
                                                    </svg>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </Fragment>
                            ) : (
                                <div className="col-span-5 h-90p flex flex-col bg-white rounded-8 pb-16">
                                    <div className="px-16 py-8 flex items-center justify-between border-b border-darwin-neutral-100">
                                        <div className="flex items-center space-x-8">
                                            <div className="flex items-center justify-center w-24 h-24 rounded-4 bg-darwin-accent-medical-history-orange-800">
                                                <svg
                                                    className="w-9 h-12 fill-white"
                                                    viewBox="0 0 9 13"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M5.03906 12.2188C6.25781 10.6953 9 7.0625 9 5C9 2.51562 6.98438 0.5 4.5 0.5C2.01562 0.5 0 2.51562 0 5C0 7.0625 2.74219 10.6953 3.9375 12.2188C4.21875 12.5703 4.75781 12.5703 5.03906 12.2188ZM4.5 6.5C3.65625 6.5 3 5.84375 3 5C3 4.17969 3.65625 3.5 4.5 3.5C5.32031 3.5 6 4.17969 6 5C6 5.84375 5.32031 6.5 4.5 6.5Z" />
                                                </svg>
                                            </div>
                                            <p className="text-14 font-700">
                                                {isCartError ? 'Cart Error' : 'Delivery Address'}
                                            </p>
                                        </div>
                                    </div>

                                    {isVerifyPincodeLoading ? (
                                        <Loader text="Address" />
                                    ) : (
                                        <div className="flex-1 flex flex-col items-center justify-center">
                                            {isCartError ? (
                                                <Fragment>
                                                    <svg
                                                        className="w-84 h-84"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 640 512"
                                                    >
                                                        <path d="M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c29.1-57 88.4-96 156.8-96c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" />
                                                    </svg>
                                                    <p className="text-14 mt-6 text-darwin-neutral-700">
                                                        Unable to build cart
                                                    </p>
                                                </Fragment>
                                            ) : (
                                                <Fragment>
                                                    <DeliveryAddressMapSVG />
                                                    <button
                                                        className="btn--small primary-btn px-16 py-8 mb-12 space-x-8"
                                                        onClick={() => {
                                                            setShowAddAddress(true);
                                                            track(
                                                                'ORDER_MEDICINE_ADDRESS_TOP_BUTTON',
                                                                {
                                                                    pxId: pxid,
                                                                },
                                                            );
                                                        }}
                                                    >
                                                        <svg
                                                            className="w-16 h-16 fill-white"
                                                            viewBox="0 0 16 16"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path d="M8 0C8.53125 0 9 0.46875 9 1V2.09375C11.5 2.53125 13.4688 4.5 13.9062 7H15C15.5312 7 16 7.46875 16 8C16 8.5625 15.5312 9 15 9H13.9062C13.4688 11.5312 11.5 13.5 9 13.9375V15C9 15.5625 8.53125 16 8 16C7.4375 16 7 15.5625 7 15V13.9375C4.46875 13.5 2.5 11.5312 2.0625 9H1C0.4375 9 0 8.5625 0 8C0 7.46875 0.4375 7 1 7H2.0625C2.5 4.5 4.46875 2.53125 7 2.09375V1C7 0.46875 7.4375 0 8 0ZM4 8C4 10.2188 5.78125 12 8 12C10.1875 12 12 10.2188 12 8C12 5.8125 10.1875 4 8 4C5.78125 4 4 5.8125 4 8ZM8 10.5C6.59375 10.5 5.5 9.40625 5.5 8C5.5 6.625 6.59375 5.5 8 5.5C9.375 5.5 10.5 6.625 10.5 8C10.5 9.40625 9.375 10.5 8 10.5Z" />
                                                        </svg>

                                                        <span className="text-14 font-700">
                                                            Add Address
                                                        </span>
                                                    </button>
                                                    <p className="text-13 text-darwin-neutral-700">
                                                        Add patient delivery address to view the
                                                        cart
                                                    </p>
                                                </Fragment>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="absolute left-16 right-16 bottom-16 flex items-center justify-between p-8 bg-actionPrimary rounded-8 space-x-16">
                            <button
                                className="text-white text-14 font-700 ml-10 py-5"
                                onClick={isForTrialOrder ? exitTrialToggleHandler : closeMe}
                            >
                                Cancel
                            </button>

                            <div className="flex items-center justify-end flex-wrap gap-10">
                                {isShow && (
                                    <button className="px-16 py-9 btn--small secondary-btn-v2">
                                        <p>Payment Mode : </p>
                                        <select
                                            className="pr-4 font-700"
                                            style={{ background: 'inherit' }}
                                            value={paymode}
                                            onChange={paymodeHandler}
                                            disabled={isInvalidPrice || isForTrialOrder}
                                        >
                                            {!isForTrialOrder && (
                                                <option value="">Select Paymode</option>
                                            )}
                                            {paymodeArray.map((i) => (
                                                <option value={i[0]}>{i[1]}</option>
                                            ))}
                                        </select>
                                    </button>
                                )}

                                {!isCartError &&
                                    (isShow &&
                                    !Object.entries(formInput).some(
                                        (i) =>
                                            (i[0] === 'line' && i[1].length === 0) ||
                                            (!IGNORE_KEYS.has(i[0]) && i[1].length < 3),
                                    ) &&
                                    pincode.length === 6 ? (
                                        cart.length === 0 || isUpdate ? (
                                            <button
                                                className="px-16 py-10 btn--small primary-btn-v2"
                                                onClick={() => updateCartHandler(pincode)}
                                                disabled={cart.length === 0}
                                            >
                                                {isApplyDiscountLoading ? (
                                                    <svg
                                                        className="w-16 h-16 fill-textColor-secondary animate-spin"
                                                        role="img"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 512 512"
                                                    >
                                                        <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                                                    </svg>
                                                ) : (
                                                    <svg
                                                        className="w-16 h-16 fill-actionPrimary"
                                                        viewBox="0 0 16 16"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M3.28125 6.34375C3.5 5.65625 3.90625 5.03125 4.4375 4.46875C6.40625 2.53125 9.5625 2.53125 11.5312 4.46875L12.0625 5H10.5C9.9375 5 9.5 5.46875 9.5 6C9.5 6.5625 9.9375 7 10.5 7H14.4688C15.0312 7 15.4688 6.5625 15.4688 6V2C15.4688 1.46875 15.0312 1 14.4688 1C13.9375 1 13.4688 1.46875 13.4688 2V3.625L12.9375 3.0625C10.1875 0.34375 5.78125 0.34375 3.03125 3.0625C2.28125 3.8125 1.71875 4.71875 1.375 5.6875C1.1875 6.21875 1.46875 6.78125 2 6.96875C2.5 7.15625 3.09375 6.875 3.28125 6.34375ZM1.21875 9.0625C1.0625 9.09375 0.90625 9.1875 0.78125 9.3125C0.65625 9.4375 0.5625 9.59375 0.53125 9.75C0.5 9.78125 0.5 9.8125 0.5 9.875C0.5 9.90625 0.5 9.96875 0.5 10.0312V14C0.5 14.5625 0.9375 15 1.5 15C2.03125 15 2.5 14.5625 2.5 14V12.4062L3.03125 12.9688C5.78125 15.6875 10.1875 15.6875 12.9375 12.9688C13.6875 12.1875 14.25 11.3125 14.5938 10.3438C14.7812 9.8125 14.5 9.25 13.9688 9.0625C13.4688 8.875 12.875 9.15625 12.6875 9.6875C12.4688 10.375 12.0625 11 11.5312 11.5625C9.5625 13.5 6.40625 13.5 4.4375 11.5625L3.90625 11H5.5C6.03125 11 6.5 10.5625 6.5 10C6.5 9.46875 6.03125 9 5.5 9H1.5C1.4375 9 1.40625 9.03125 1.34375 9.03125C1.3125 9.03125 1.25 9.03125 1.21875 9.0625Z" />
                                                    </svg>
                                                )}
                                                <span className="text-14 font-700">
                                                    Update cart
                                                </span>
                                            </button>
                                        ) : (
                                            <button
                                                className="px-16 py-10 btn--small primary-btn-v2"
                                                onClick={placeOrderHandler}
                                                disabled={isPlaceOrderLoading}
                                                id="place-order"
                                            >
                                                <div className="flex items-center justify-center w-16 h-16">
                                                    {isPlaceOrderLoading ? (
                                                        <svg
                                                            className="w-16 h-16 fill-textColor-secondary animate-spin"
                                                            role="img"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 512 512"
                                                        >
                                                            <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                                                        </svg>
                                                    ) : (
                                                        <svg
                                                            className="w-16 h-16 fill-actionPrimary"
                                                            role="img"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 448 512"
                                                        >
                                                            <path d="M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z"></path>
                                                        </svg>
                                                    )}
                                                </div>
                                                <p>
                                                    Place Order
                                                    {!isInvalidPrice &&
                                                        ` for ₹ ${response?.totalAmount?.toFixed(
                                                            2,
                                                        )}`}
                                                </p>
                                            </button>
                                        )
                                    ) : (
                                        <button
                                            className="px-16 py-10 btn--small primary-btn-v2"
                                            onClick={() => {
                                                setShowAddAddress(true);
                                                setIsNewAddress(false);
                                                setShowForm(true);
                                                track('ORDER_MEDICINE_ADDRESS_BOTTOM_BUTTON', {
                                                    pxId: pxid,
                                                });
                                            }}
                                        >
                                            <svg
                                                className="w-16 h-16 fill-darwin-primary-500"
                                                viewBox="0 0 16 16"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M8 0C8.53125 0 9 0.46875 9 1V2.09375C11.5 2.53125 13.4688 4.5 13.9062 7H15C15.5312 7 16 7.46875 16 8C16 8.5625 15.5312 9 15 9H13.9062C13.4688 11.5312 11.5 13.5 9 13.9375V15C9 15.5625 8.53125 16 8 16C7.4375 16 7 15.5625 7 15V13.9375C4.46875 13.5 2.5 11.5312 2.0625 9H1C0.4375 9 0 8.5625 0 8C0 7.46875 0.4375 7 1 7H2.0625C2.5 4.5 4.46875 2.53125 7 2.09375V1C7 0.46875 7.4375 0 8 0ZM4 8C4 10.2188 5.78125 12 8 12C10.1875 12 12 10.2188 12 8C12 5.8125 10.1875 4 8 4C5.78125 4 4 5.8125 4 8ZM8 10.5C6.59375 10.5 5.5 9.40625 5.5 8C5.5 6.625 6.59375 5.5 8 5.5C9.375 5.5 10.5 6.625 10.5 8C10.5 9.40625 9.375 10.5 8 10.5Z" />
                                            </svg>

                                            <span className="text-14 font-700">Add Address</span>
                                        </button>
                                    ))}
                            </div>
                        </div>
                    </Fragment>
                )}

                {isInvalidPrice && !finishState && (
                    <div className="flex space-x-8 px-12 py-8 bg-darwin-neutral-900 rounded-8 absolute right-16 bottom-80 text-white text-12">
                        <svg
                            className="w-12 h-12 fill-white mt-3"
                            viewBox="0 0 16 16"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M8 16C3.5625 16 0 12.4375 0 8C0 3.59375 3.5625 0 8 0C12.4062 0 16 3.59375 16 8C16 12.4375 12.4062 16 8 16ZM6.75 10.5C6.3125 10.5 6 10.8438 6 11.25C6 11.6875 6.3125 12 6.75 12H9.25C9.65625 12 10 11.6875 10 11.25C10 10.8438 9.65625 10.5 9.25 10.5H9V7.75C9 7.34375 8.65625 7 8.25 7H6.75C6.3125 7 6 7.34375 6 7.75C6 8.1875 6.3125 8.5 6.75 8.5H7.5V10.5H6.75ZM8 6C8.53125 6 9 5.5625 9 5C9 4.46875 8.53125 4 8 4C7.4375 4 7 4.46875 7 5C7 5.5625 7.4375 6 8 6Z" />
                        </svg>

                        <div className="space-y-3">
                            <p>
                                Final price will be available and confirmed with the customer at
                                dispatch.
                            </p>
                            <p className="font-700">You can continue placing the order.</p>
                        </div>
                    </div>
                )}
            </div>
            {finishState && finishState.length > 1 && (
                <p className="absolute bottom-0 right-0 left-0 bg-white p-5 text-center text-13 text-darwin-accent-bright-yellow-900 font-700 border-t border-darwin-neutral-100">
                    This order was split into {finishState.length} orders.
                </p>
            )}
            {showAddAddress && (
                <AddAddressModal
                    closeMe={() => setShowAddAddress(false)}
                    setAddress={setAddressHandler}
                    formInp={showForm && !isNewAddress ? { ...formInput, pincode } : undefined}
                    patientId={patientId}
                    currentOptionId={formInput._id}
                    showForm={showForm}
                    pincode={pincode}
                />
            )}
            {showAddRecipient && (
                <AddRecipientModal
                    closeMe={() => setShowAddRecipient(false)}
                    setRecipient={setRecipientHandler}
                    recipientDetails={recipientDetails}
                    numberError={numberError || 'mobile'}
                />
            )}
            {showSelectPaymode && (
                <SelectPaymodeModal
                    closeMe={() => setShowSelectPaymode(false)}
                    paymode={paymode}
                    setPaymode={setPaymode}
                    paymodeArray={paymodeArray}
                />
            )}
            {showUnavailablePriceFAQs && (
                <UnavailablePriceFAQsModal closeMe={() => setShowUnavailablePriceFAQs(false)} />
            )}

            {showExitTrialWarningModal && (
                <ExitTrialWarningModal type={'pharma'} onResumeTrial={exitTrialToggleHandler} />
            )}

            {isForTrialOrder && (
                <ShepherdTour
                    steps={getSteps(changeSteps)}
                    tourOptions={{
                        defaultStepOptions: {
                            cancelIcon: {
                                enabled: true,
                            },
                            highlightClass: 'highlight',
                            scrollTo: true,
                        },
                        exitOnEsc: true,
                    }}
                >
                    <Button />
                </ShepherdTour>
            )}

            {activeOrder && (
                <CancelOrderOrBooking
                    activeTab={ACTIVE_TAB.MEDS}
                    orderDetails={activeOrder}
                    onClose={() => toggleActiveOrder(undefined)}
                    onRefresh={onRefresh}
                />
            )}
        </Fragment>
    );
};

export default OrderMedicine;

export const OrderMedicineDialog: React.FC<{
    closeMe: () => void;
    formData: PatientFormData[];
    patientId: string;
    name: string;
    phone: string;
    gender: string;
    pxid: string;
    age: number;
    clinicPin: string;
    orderId?: string;
    showGoToHEDashboardButton?: boolean;
    isForQuickCart?: boolean;
    patient?: Patient;
}> = ({
    closeMe,
    formData,
    patientId,
    name,
    phone,
    gender,
    pxid,
    age,
    clinicPin,
    orderId,
    showGoToHEDashboardButton,
    isForQuickCart,
    patient,
}) => {
    return (
        <Hotkeys keyName="esc" onKeyDown={closeMe}>
            <SlideFromRightWrapper closeMe={closeMe} cssClass="w-80p">
                <OrderMedicine
                    closeMe={closeMe}
                    formData={formData}
                    pxid={pxid}
                    patientId={patientId}
                    name={name}
                    phone={phone}
                    gender={gender}
                    age={age}
                    clinicPin={clinicPin}
                    orderId={orderId}
                    showGoToHEDashboardButton={showGoToHEDashboardButton}
                    isForQuickCart={isForQuickCart}
                    patient={patient}
                />
            </SlideFromRightWrapper>
        </Hotkeys>
    );
};
